import {
  AutodiscoveryFileUpload,
  AutodiscoveryUrl,
} from "@intentsify/types";

const getFileSizeFromUrl = async (url: string): Promise<string | null> => {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open("HEAD", url, true);

    xhr.onreadystatechange = function () {
      if (this.readyState === this.DONE) {
        resolve(xhr.getResponseHeader("Content-Length"));
      }
    };
    xhr.send();
  });
};

const getFileNameFromUrl = (url: string): string | undefined => {
  try {
    const urlWithoutQuery = url.split("?")[0];

    const fileName = urlWithoutQuery.split("/").pop();
    if (!fileName) {
      return undefined;
    }

    const decodedFileName = decodeURIComponent(fileName);

    return decodedFileName;
  } catch (error) {
    console.error("Error extracting filename from URL:", error);
    return undefined;
  }
};

const mergeUploadedAutodiscoveryFiles = (
  currentFiles: AutodiscoveryUrl[],
  uploadedFiles: AutodiscoveryFileUpload[],
): AutodiscoveryUrl[] => {
  const uploadsWithIds = uploadedFiles.filter(
    (file): file is AutodiscoveryFileUpload & { id: number } =>
      file.id !== undefined,
  );
  const uploadedById = new Map(uploadsWithIds.map((file) => [file.id, file]));
  const uploadedByDurableUrl = new Map(
    uploadsWithIds.map((file) => [file.url.split("?")[0], file]),
  );
  const merged = currentFiles.map((file) => {
    const uploaded =
      uploadedById.get(file.id) ??
      uploadedByDurableUrl.get(file.url.split("?")[0]);
    if (!uploaded) {
      return file;
    }

    uploadedById.delete(uploaded.id);
    uploadedByDurableUrl.delete(uploaded.url.split("?")[0]);
    return {
      id: uploaded.id,
      url: uploaded.url,
      status: null,
      isFile: true,
    };
  });

  return [
    ...merged,
    ...[...uploadedById.values()].map((file) => ({
      id: file.id,
      url: file.url,
      status: null,
      isFile: true,
    })),
  ];
};

export {
  getFileNameFromUrl,
  getFileSizeFromUrl,
  mergeUploadedAutodiscoveryFiles,
};
